var toLocaleString = function (n) { return (+n).toLocaleString(); };
var toString = function (n) { return "" + n; };
var floor = Math.floor, ceil = Math.ceil, min = Math.min, max = Math.max;
export var roundValue = function (value, isCeil, parsedNumber, limit) {
    var cloneValue = +value;
    var limitValue = typeof limit === "function" ? limit(value) : limit;
    if (cloneValue > limitValue) {
        var parsedValue = isCeil ? ceil(parsedNumber) : floor(parsedNumber);
        return floor(parsedValue);
    }
    var prevValue = +value;
    cloneValue = isCeil ? ceil(parsedNumber) : floor(parsedNumber * 100) / 100;
    if (cloneValue === 0 && prevValue > 0) {
        cloneValue = 0.01;
    }
    return cloneValue;
};
export var createStringForDigits = function (digits, digitsCount) {
    var array = [];
    var digitLength = digits.length;
    for (var i = 0; i < digitsCount; i++) {
        array.push(i < digitLength ? digits.charAt(i) : "0");
    }
    return array.join("");
};
export var toFixedNumber = function (value, formatProperty) {
    var minFractionDigits = formatProperty.minFractionDigits, maxFractionDigits = formatProperty.maxFractionDigits, additionalLimitations = formatProperty.additionalLimitations;
    var strValue = toString(value);
    if (strValue.indexOf(".") === -1 && minFractionDigits === 0) {
        return toLocaleString(value);
    }
    var splitNumber = strValue.split(".");
    var fractionDigitsAfterDot = splitNumber[1] || "";
    var localizedString = toLocaleString(splitNumber[0]);
    if (maxFractionDigits === 0) {
        return localizedString;
    }
    var maxLength = min(fractionDigitsAfterDot.length, maxFractionDigits);
    var fractionsLength = max(maxLength, minFractionDigits);
    var decimalNumber = createStringForDigits(fractionDigitsAfterDot, fractionsLength);
    if (minFractionDigits === 0 && +decimalNumber === 0) {
        return localizedString;
    }
    var resultString = localizedString + "." + decimalNumber;
    if (additionalLimitations === null || additionalLimitations === void 0 ? void 0 : additionalLimitations.fractionDigitLength) {
        var fractionDigitLength = additionalLimitations.fractionDigitLength;
        for (var i = 0; i < fractionDigitLength.length; i++) {
            var item = fractionDigitLength[i];
            if (item.length <= splitNumber[0].length) {
                var newFractionDigits = createStringForDigits(fractionDigitsAfterDot, item.maxFractionDigit);
                return item.maxFractionDigit ? localizedString + "." + newFractionDigits : localizedString;
            }
        }
    }
    return resultString;
};
export var formatNumber = function (formatProperty, incomingValue) {
    var parsedNumber = parseFloat(incomingValue);
    var inputValues = formatProperty.inputValues, isCeil = formatProperty.isCeil, limit = formatProperty.limit;
    if (isNaN(parsedNumber)) {
        return "-";
    }
    var value = roundValue(+incomingValue, isCeil, parsedNumber, limit);
    var _a = calculateNewValueAndSuffix(value, inputValues), newValue = _a[0], suffix = _a[1];
    value = newValue > 0 ? newValue : value;
    return toFixedNumber(value, formatProperty) + suffix;
};
export var calculateNewValueAndSuffix = function (value, inputValues) {
    var newValue = 0;
    var suffix = "";
    inputValues.forEach(function (item) {
        var limitValue = item.limitValue, divideBy500 = item.divideBy500, inputValue = item.inputValue, divideBy = item.divideBy, itemSuffix = item.suffix, limitIncludeFraction = item.limitIncludeFraction;
        if (value <= inputValue) {
            return;
        }
        var strValue = "" + value;
        if (strValue.indexOf(".") === -1) {
            if (strValue.length >= limitValue || (divideBy500 && value % 500 === 0)) {
                newValue = value / divideBy;
                suffix = itemSuffix;
            }
            return;
        }
        if (limitIncludeFraction) {
            if (strValue.length - 1 >= limitValue) {
                newValue = value / divideBy;
                suffix = itemSuffix;
            }
            return;
        }
        var split = strValue.split(".");
        if (split[0].length >= limitValue) {
            newValue = value / divideBy;
            suffix = itemSuffix;
        }
    });
    return [newValue, suffix];
};
